import { formatDate } from '@btime/helpers'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { triggersClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useOpenEditTriggerModal } from '../../../../utils/routes/modals/modalsActions'
import { useRowActionsColumn } from '../../../../components/tables/Table'
import { useRowsActions } from './_actions/rowsActions'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import Link from '../../../../packages/kiti/components/actions/Link'
import SwitchDisabled from '../../../../components/helpers/disabled/SwitchDisabled'
import Tag from '../../../../packages/kiti/components/presentation/Tag'
import Text, { SmallText } from '../../../../packages/kiti/components/presentation/Text'
import TriggerSentence from '../../../../containers/triggers/TriggerSentence'
import TriggersLoader, { useTriggers } from './_load/TriggersLoader'

const TriggersTable = props => {
  const { t } = useTranslation(['triggers', 'common'])
  const { entities } = useModalData() || {}
  const triggers = useTriggers()
  const canEdit = useSessionPermission('editTrigger')
  const openEditModal = useOpenEditTriggerModal()

  const columns = [
    {
      label: t('triggers:name'),
      sortIndex: false,
      flex: 12,
      render: (_, record) => (
        <Link onClick={() => openEditModal({ id: record.id, entities })}>
          {record.readOnly && <Tag label={t('triggers:readOnly')} color="yellow" size="small" />}
          {record.name ? <Text bold>{record.name}</Text> : <TriggerSentence trigger={record} />}
        </Link>
      )
    },

    {
      label: t('common:updatedAt'),
      dataIndex: 'updatedAt',
      sortIndex: 'UPDATED_AT',
      flex: 2,
      render: value => (
        <>
          {props.hideHeader && <SmallText size="xxsmall">{t('common:updatedAt')}:</SmallText>}
          <SmallText>{formatDate('DD/MM/YYYY HH:mm', value)}</SmallText>
        </>
      )
    },

    {
      label: t('triggers:enabled'),
      dataIndex: 'enabled',
      sortIndex: 'ENABLED',
      flex: 1,
      render: (_, record) => (
        <SwitchDisabled client={triggersClient} entity="Trigger" record={record} size="small" disabled={!canEdit} />
      )
    },

    {
      label: t('common:actions'),
      flex: 1,
      render: useRowActionsColumn(useRowsActions)
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={triggers} size="medium" {...props} />
}

const Wrapper = ({ folder, ...props }) => {
  return (
    <TriggersLoader folder={folder}>
      <TriggersTable {...props} />
    </TriggersLoader>
  )
}

export default Wrapper
